module.exports = __webpack_public_path__ + "static/media/backbreaker-art.032f7041.png";